module.exports = __webpack_public_path__ + "img/row-srp-preview-ford.573bff2b.png";